<template>
    <v-dialog v-model="show" no-click-animation persistent width="800">
        <div class="AgentVariable">
            <div class="dialog-header">
                <div>{{ $f.tc('variable') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar" style="max-height: 400px" ref="contentDialog">
                <table>
                    <thead style="position: sticky !important; top: -1px; z-index:1">
                    <!-- this tr is for border top to follow the header when scrolling -->
                    <tr style="height: 2px !important">
                        <th style="padding:0;background: #96add0" colspan="6"></th>
                    </tr>
                    <tr>
                        <th style="padding: 12px; width: 200px">
                            <div class="d-flex">
                                {{ $f.tc('name') }}
                            </div>
                        </th>
                        <th>{{ $f.tc('description') }}</th>
                        <th>{{ $f.tc('defaultValue') }}</th>
                        <th class="text-center" style="width: 90px">
                            <div class="centerXY  ">
                                {{ $f.tc('save') }}
                                <div class="tooltip">
                                    <v-icon size="16" color="#0052CC" class="ml-1">
                                        mdi-help-circle
                                    </v-icon>
                                    <p class="tooltiptext" style="top:37px; right:60px">
                                        {{ $t('scenarioVariable.helpCircle') }}</p>
                                </div>

                            </div>
                        </th>
                        <th v-if="isEdit"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--Current variables-->
                    <tr v-for="(item, i) in itemList" :key="i">
                        <td>
                            <v-text-field
                                outlined
                                v-model="itemList[i].name"
                                style="width: 100%"
                                class="input-custom"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="itemList[i].description"
                                class="input-custom"
                                style="width: 100%"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="itemList[i].default_value"
                                class="input-custom"
                                style="width: 100%"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                v-model="itemList[i].should_save"
                                :disabled="!isEdit"
                                color="#0052CC"
                                style="margin-left: 26px;margin-bottom: 15px"
                            ></v-checkbox>
                        </td>
                        <td v-if="isEdit">
                            <v-btn icon class="mx-0" @click.stop="deleteItem(i)">
                                <img
                                    src="/img/delete-blue.svg"
                                    alt="icon-delete"
                                    style="transform: scale(1.3); padding-left: 1px"
                                >
                            </v-btn>
                        </td>
                    </tr>
                    <!--New variable-->
                    <tr v-if="isEdit">
                        <td>
                            <v-text-field
                                outlined
                                v-model="model.name"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('enterName')"
                                style="width: 100%"
                                ref="NewKeyVariable"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="model.description"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('enterDescription')"
                                style="width: 100%"
                                ref="NewKeyVariable"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="model.default_value"
                                class="input-custom"
                                @keypress.enter="addItem"
                                :placeholder="$f.tc('enterDefaultValue')"
                                style="width: 100%"
                                ref="NewKeyVariable"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-checkbox
                                hide-details
                                style="margin-left: 26px;margin-bottom: 15px"
                                v-model="model.should_save"
                                color="#0052CC"
                            ></v-checkbox>
                        </td>
                        <td>
                            <v-btn icon class="mx-0" @click.stop="addItem">
                                <img src="/img/add-blue.svg" alt="icon-delete" style="transform: scale(1.4);">
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer" v-if="isEdit">
                <div class="btn-custom"
                     @click="saveList">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import {mapState} from "vuex";
import AgentService from "@/services/agent.service";
import lodash from "lodash";
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";

const defaultNewVariable = {
    name: '',
    description: '',
    default_value: '',
    should_save: false
}

export default {
    name: 'AgentVariable',
    mixins: [DialogPromiseMixin],
    computed: {
        ...mapState({
            variableSetting: state => state.agent.variable
        }),
        isEdit() {
            return AgentService.isEditable()
        },
        originalItemMap() {
            return this.$utils.cloneObject(this.variableSetting.value)
        }
    },
    data() {
        return {
            model: this.$utils.cloneObject(defaultNewVariable),
            itemList: [],
            show: false
        }
    },
    methods: {
        open() {
            this.model = this.$utils.cloneObject(defaultNewVariable)
            this.show = true
            this.loadVariable(this.variableSetting)
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        deleteItem(index) {
            this.itemList.splice(index, 1)
        },
        addItem() {
            if (this.newVariableIsValid()) {
                this.itemList.push(this.model)
                this.scrollBottom()
                this.model = this.$utils.cloneObject(defaultNewVariable)
                this.$refs.NewKeyVariable.$el.focus()
            }
        },
        newVariableIsValid() {
            if (!this.model.name.trim()) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('name')}))
                return false
            }
            if (!this.model.description.trim()) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('description')}))
                return false
            }
            for (let key in this.model) {
                if (key !== 'should_save') {
                    this.model[key] = this.model[key].trim()
                }
            }

            if (this.itemList.find(item => item.name === this.model.name)) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicate', {
                    key: this.$f.tc('name'),
                    value: this.model.name
                }))
                return false
            }

            return true
        },
        saveList() {
            if (this.validateItemList() && !lodash.isEqual(this.itemList, this.originalItemMap)) {
                this.trimItemList()
                this.$store.dispatch(this.$actionTypes.agent.UPDATE_VARIABLE, {
                    id: this.variableSetting.id,
                    value: this.itemList
                }).then(() => {
                    this.close()
                })
            }
        },
        validateItemList() {
            // check empty key
            for (let item of this.itemList) {
                for (let key in item) {
                    if (['default_value', 'should_save'].includes(key)) {
                        continue
                    }
                    if (!item[key].trim()) {
                        this.$appService.toastError(this.$f.tc('fieldItemEmpty'))
                        return false
                    }
                }
            }
            // check duplicate
            let set = new Set(this.itemList.flatMap(i => i.name))
            if (set.size !== this.itemList.length) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicateExist', {key: this.$f.tc('name')}))
                return false
            }

            return true
        },
        scrollBottom() {
            this.$nextTick(() => {
                this.$refs.contentDialog.scrollTo({
                    top: this.$refs.contentDialog.scrollHeight
                })
            })
        },
        loadVariable(val) {
            this.itemList = lodash.orderBy(this.$utils.cloneObject(val.value), 'name')
        },
        close() {
            this.show = false
            this.itemList = []
            this.$emit('close')
        },
        trimItemList() {
            this.itemList.map(function (item) {
                for (let key in item) {
                    if (key !== 'should_save') {
                        item[key] = item[key].trim()
                    }
                }
            })
        }
    },
    watch: {
        variableSetting: {
            deep: true,
            handler: function (newVal) {
                this.loadVariable(newVal)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.AgentVariable {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        margin: 12px 0 0 12px;
        padding: 0 12px 12px 0 !important;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
        position: relative;
    }

    .btn-custom {
        margin-right: 8px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    tr {
        border-bottom: 1px solid #96add0;
    }

    tr {
        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }
}

.tooltip .tooltiptext {
    background-color: #808080;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 4px;
    font-size: 11px;
    font-family: "open sans", serif;
    display: none;
    position: absolute;
}

.tooltip:hover .tooltiptext {
    display: block;
}
</style>
